module.exports = __webpack_public_path__ + "static/media/logo.f68d5ba8.svg";